export default "__VITE_ASSET__BWEI0nr7__"